import loggerService from '../../utils/loggerService';
import { SOURCE } from '../../constants/logger';

const exceptionHandler = (exception, cause) => {
  try {
    loggerService.error(exception, {
      context: { cause },
      tags: { source: SOURCE.angular },
    });
  } catch (error) {
    loggerService.error(error, {
      context: { cause },
      tags: { source: SOURCE.angular },
    });
  }
};

export { exceptionHandler };

if (app) {
  app.factory('$exceptionHandler', [() => exceptionHandler]);
}
